import { collection, getFirestore } from 'firebase/firestore';
import FirebaseCollection from '../../../abstract/FirebaseCollection';
import InventoryItemState from './InventoryItemState';

class InventoryState extends FirebaseCollection {
  constructor(root, property) {
    super(root, {
      ref: collection(
        getFirestore(),
        `properties/${property.id}/inventoryItems`
      ),
      ItemClass: InventoryItemState,
    });

    this.property = property;
  }
}

InventoryState.annotations = {
  ...FirebaseCollection.annotations,
};

export default InventoryState;
